// Initialize skip to main content functionality after Vue is mounted
import $ from "jquery";

function initSkipToMain() {
  const $skipLink = $(".skip-to-main");

  if ($skipLink.length) {
    $skipLink.on("click", function (e) {
      e.preventDefault();

      const $mainContent = $("#page-content");
      if ($mainContent.length) {
        $("html, body").animate(
          {
            scrollTop: $mainContent.offset().top - 20, // 20px offset to show the top border
          },
          300
        );

        $mainContent.focus();
      }
    });
  }
}

// Wait for Vue to be mounted before initializing
$(document).ready(() => {
  // Give Vue a moment to mount
  setTimeout(initSkipToMain, 100);
});
